import React from "react"
import { batch } from "@preact/signals-react"

import { AppTiersAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import { tiers, providers, providersbyTiers, providersList } from "@signals"
import { useToast } from "@hooks"


export default function TiersAutocomplete({ ...props }) {
	const { showToast } = useToast()

	return <AppTiersAutocomplete
		value={tiers.value}
		onChange={e => {
			batch(() => {
				tiers.value = e.target.value
				if (providersbyTiers.value?.filter(a => a.tierID === e.target.value)[0].providers.some(p => providersList.value.includes(p))) {
					providers.value = providersbyTiers.value.filter(a => a.tierID === e.target.value).map(b => b.providers).pop()
				} else {
					providers.value = []
					showToast.warning("The selected tier contains providers that are not available in the current filter. As a result, no filtering will be applied for providers.")
				}
			})
		}}
		onFinishAjax={options => providersbyTiers.value = options.map(a => ({
			tierID: a.value,
			providers: a.providers
		}))}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
		{...props}
	/>
}